import { render, staticRenderFns } from "./NewUiAccordion.vue?vue&type=template&id=5b17d4df&"
import script from "./NewUiAccordion.vue?vue&type=script&lang=ts&"
export * from "./NewUiAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./NewUiAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports